// extracted by mini-css-extract-plugin
module.exports = {"selected":"playerlist_selected__3Xp42"};